import React from 'react';

const CheckCircleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M9.99982 1.66699C5.39748 1.66699 1.6665 5.39797 1.6665 10.0003C1.6665 14.6027 5.39748 18.3337 9.99982 18.3337C14.6022 18.3337 18.3332 14.6027 18.3332 10.0003C18.3332 5.39797 14.6022 1.66699 9.99982 1.66699ZM13.1379 7.02301L14.3163 8.20141L9.1665 13.3728L6.07732 10.2836L7.25568 9.10523L9.1665 11.0161L13.1379 7.02301Z" fill="#FFF"/>
  </svg>
);

export default CheckCircleIcon;
